import { Box } from '@mui/material';
import styled from 'styled-components';
import { colors, fontSize, fontWeight } from '../../theme';

export const QuestionSettingsBoxStyled = styled(Box)`
    background: ${colors.grey800};
    border-radius: 8px;
    color: ${colors.grey400};
    display: flex;
    flex-direction: column;
    font-size: ${fontSize.sm};
    font-weight: ${fontWeight.semiRegular};
    gap: 20px;
    left: 50%;
    max-height: 85vh;
    overflow-y: auto;
    padding: 32px;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 660px;
    &:focus-visible {
        outline: none;
    }
    &::-webkit-scrollbar {
        width: 4px;
        background-color: ${colors.grey600};
    }
    &::-webkit-scrollbar-thumb {
        background-color: ${colors.grey400};
        border-radius: 4px;
    }
`;

export const SettingsCloseButtonStyled = styled.button`
    background: none;
    border: none;
    border-radius: 4px;
    color: ${colors.grey400};
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: 4px;
    position: absolute;
    right: 16px;
    top: 16px;
    &:hover {
        background-color: ${colors.grey600};
        color: ${colors.grey100};
    }
`;

export const SettingsHeaderStyled = styled.div`
    display: flex;
    align-items: baseline;
    gap: 10px;
`;

export const SettingsSectionStyled = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const SettingsSectionTitleStyled = styled.div`
    border-bottom: 1px solid ${colors.grey600};
    color: ${colors.grey200};
    font-size: ${fontSize.sm};
    font-weight: ${fontWeight.semiBold};
    padding-bottom: 6px;
`;

export const SettingsLabelInputStyled = styled.input`
    background: ${colors.grey700};
    border: 1px solid ${colors.grey500};
    border-radius: 6px;
    box-sizing: border-box;
    color: ${colors.grey100};
    font-family: Barlow, sans-serif;
    font-size: ${fontSize.sm};
    outline: none;
    padding: 8px 12px;
    width: 100%;
    &:focus {
        border-color: ${colors.default};
    }
`;

export const CheckboxRowStyled = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
`;

export const ResponsesListStyled = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    max-height: 260px;
    overflow-y: auto;
    &::-webkit-scrollbar {
        width: 2px;
        background-color: ${colors.grey600};
    }
    &::-webkit-scrollbar-thumb {
        background-color: ${colors.grey400};
    }
`;

interface ResponseItemStyledProps {
    excluded: boolean;
}

export const ResponseItemStyled = styled.div<ResponseItemStyledProps>`
    align-items: center;
    background-color: ${colors.grey700};
    border: 1px solid ${colors.grey600};
    border-radius: 6px;
    display: flex;
    gap: 8px;
    opacity: ${({ excluded }: ResponseItemStyledProps) => (excluded ? 0.5 : 1)};
    padding: 4px 8px;
`;

export const ResponseInputStyled = styled.input`
    background: transparent;
    border: none;
    color: ${colors.grey100};
    flex: 1;
    font-family: Barlow, sans-serif;
    font-size: ${fontSize.s};
    min-width: 0;
    outline: none;
    &:focus {
        background-color: ${colors.grey600};
        border-radius: 4px;
        padding: 2px 4px;
    }
`;

export const ResponseNumericInputStyled = styled.input`
    background: ${colors.grey600};
    border: 1px solid ${colors.grey500};
    border-radius: 4px;
    color: ${colors.grey100};
    flex-shrink: 0;
    font-family: Barlow, sans-serif;
    font-size: ${fontSize.s};
    outline: none;
    padding: 3px 6px;
    text-align: right;
    width: 72px;
    &:focus {
        border-color: ${colors.default};
    }
`;

export const SettingsFooterStyled = styled.div`
    border-top: 1px solid ${colors.grey600};
    display: flex;
    gap: 8px;
    justify-content: flex-end;
    padding-top: 16px;
`;
